import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmAnimation } from './confirm/confirm.animation';
import { EsllipsisAnimation } from './ellipsis/ellipsis.animation';
import { ErrorAnimation } from './error/error.animation';
import { SpinnerAnimation } from './spinner/spinner.animation';

@NgModule({
  declarations: [
    SpinnerAnimation,
    ConfirmAnimation,
    ErrorAnimation,
    EsllipsisAnimation,
  ],
  imports: [CommonModule],
  exports: [
    SpinnerAnimation,
    ConfirmAnimation,
    ErrorAnimation,
    EsllipsisAnimation,
  ],
  providers: [],
})
export class AnimationsModule {}
